<template>
    <div>
        <Header />
        <br/>
        <div class="title4 mt90">
            <h2 class="title-inner4">
                <router-link :to="{ path: '/shop' }" class="goto-before"><i class="fa fa-chevron-left"></i></router-link>
                {{productslist[listIndex].grouptitle}}
            </h2>
        </div>
        <div class="boxes addtocart_count">
        <div class="product-box" v-for="(product, index) in productslist[listIndex].products" :key="index">
            <productBox
                @opencartmodel="showCartModal"
                :product="product"
                :index="index"
            />
        </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from '@/components/headershop'
import productBox from '@/components/product-box/home-product-box'
import Footer from '@/components/footer'

export default {
    components: {
        Header, Footer, productBox
    },
    computed: {
        ...mapState({
            productslist: state => state.products.productslist,
        }),
        listIndex() {
            return this.$route.params.id;
        }
    }
}
</script>
<style scoped>
    .mt90 {
        margin-top: 90px;
    }
    .boxes {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .goto-before{
        color: #373838;
        margin-right: 10px;
    }
</style>
